// Selector de opciones frecuentes + «Otro…» con texto libre. El valor que sale es la opción elegida o el texto
// escrito. Sin estado de página: recibe el valor y avisa los cambios.
import { useId, useState } from 'react';
import { OTRO } from '../lib/opciones-condiciones';

interface Props {
  etiqueta: string;
  opciones: readonly string[];
  valor: string;
  onChange: (v: string) => void;
  disabled?: boolean;
}

export function SelectorConOtro({ etiqueta, opciones, valor, onChange, disabled }: Props) {
  // Si el valor no es una de las opciones, la persona está en «Otro…».
  const [otro, setOtro] = useState(() => !opciones.includes(valor));
  const id = useId();
  const enOtro = otro || !opciones.includes(valor);

  return (
    <div>
      <label className="pd-field-label" htmlFor={id}>
        {etiqueta}
      </label>
      <select
        id={id}
        className="pd-field-input"
        disabled={disabled}
        value={enOtro ? OTRO : valor}
        onChange={(e) => {
          if (e.target.value === OTRO) {
            setOtro(true);
            onChange('');
          } else {
            setOtro(false);
            onChange(e.target.value);
          }
        }}
      >
        {opciones.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
        <option value={OTRO}>{OTRO}</option>
      </select>
      {enOtro && (
        <input
          className="pd-field-input"
          style={{ marginTop: 6 }}
          aria-label={`${etiqueta} (texto libre)`}
          disabled={disabled}
          value={valor}
          maxLength={120}
          placeholder="Escribí el valor que sale en el documento"
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </div>
  );
}
